import * as v2 from '@/core/services/api/v2';

/**
 * A roleta, no backend V2.
 *
 * Duas diferenças de contrato em relação ao Strapi:
 *
 * - As rotas passaram a ser por jogador (`/player/:id/roulette/...`), então
 *   `getPrizes` agora pede o `playerId` — a lista da roda e o sorteio saem da
 *   **mesma** fonte, e o prêmio sorteado sempre existe entre os segmentos.
 * - **Não existe mais o passo de `claim`**: o prêmio é creditado dentro do
 *   próprio spin, numa transação do servidor. O antigo `giveReward` deixava o
 *   cliente dizer qual prêmio recebeu — qualquer um com o DevTools aberto
 *   reivindicava o melhor da roda.
 */
export default {
  /** Os segmentos da roda: `[{ id, name, type, value }]`. */
  async getPrizes(playerId) {
    return v2.premiosDaRoleta(playerId);
  },

  /** Gira e já credita. Devolve `{ name, type, value }` do prêmio sorteado. */
  async spinRoulette(playerId) {
    return v2.girarRoleta(playerId);
  }
};
